export default {
  name: 'NotificationManagement',

  data: () => ({

      active_step: 1,
      selected_channels: [],
      recipient_groups: [
        { role_type: "", role_name: "" } // start with one select group
      ],
      conditions: [
        { entity_type: "", operator: "equals", value: "" } // start with one condition row
      ],
      errors: {}
  }),

  methods: {
    nextStep() {
      if (this.validateStep()) {
        if (this.active_step < 5) {
          this.active_step++;
        }
      }
    },

    previous_step() {
      if (this.active_step > 1) {
        this.active_step--;
      }
    },

    add_recipient_group() {
      this.recipient_groups.push({ role_type: "", role_name: "" });
    },

    remove_recipient(index) {
      this.recipient_groups.splice(index, 1);
    },

    add_condition() {
      this.conditions.push({ entity_type: "", operator: "equals", value: "" });
    },

    remove_condition(index) {
      this.conditions.splice(index, 1);
    },
  }
};
